export const lightTheme = {
  name: "light",
  object: "#0079C1",
  background: "#D6F1FF",
  headerTitle: "#004C72",
  headerSubtitle: "#004F7E",
  itemBackground: "#FFFFFF",
  expandedBackground: "#8BD8FF",
  description: "#000000",
  statsBackground: "#FFFFFF",
  sidebarBackground: "#004F7E",
  sidebarShadow: "none",
  sidebarText: "#D1EEFE",
}
// Dark mode
export const darkTheme = {
  name: "dark",
  object: "#434B83",
  background: "#252A49",
  headerTitle: "#99AAB5",
  headerSubtitle: "#FFFFFF",
  itemBackground: "#2E3359",
  expandedBackground: "#2E3359",
  statsBackground: "#202541",
  description: "white",
  sidebarBackground: "#191D33",
  sidebarShadow: "none",
  sidebarText: "#D1EEFE",
}
